export default {
    SETACCOUNTS(state, companies) {
        state.accountsList = [...companies];
    },
    SETNUMBEROFRESULTS(state, numberOfResults) {
        state.numberOfResults = numberOfResults;
    },
}